/** Rail sidebar — localStorage, comme le thème. */

export const FX_SIDEBAR_KEY = "facturx_sidebar";

export function readFxSidebarSlim(): boolean {
  try {
    return localStorage.getItem(FX_SIDEBAR_KEY) === "slim";
  } catch {
    return false;
  }
}

export function persistFxSidebarSlim(slim: boolean): void {
  try {
    localStorage.setItem(FX_SIDEBAR_KEY, slim ? "slim" : "open");
  } catch {
    /* ignore */
  }
}
